"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _core = _interopRequireDefault(require("./core"));
var _logger = _interopRequireDefault(require("../logger"));
var _uuid = require("uuid");
var _pako = _interopRequireDefault(require("pako"));
var _bops = _interopRequireDefault(require("bops"));
var _encryption = _interopRequireDefault(require("../encryption"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Print = exports["default"] = /*#__PURE__*/function (_Core) {
  function Print(props, printerControlsAcceptors) {
    var _this;
    (0, _classCallCheck2["default"])(this, Print);
    _this = _callSuper(this, Print, [props]);
    _this.connection = props.connection;
    _this.printerControlsAcceptors = true;
    _this.appName = props.appName;
    _this.cryptoKey = props.cryptoKey;
    _this.publicKey = props.publicKey;
    _this.services = props.services;
    _this._events = {};
    _this.myServices = ["pps"];
    _this.ready = false;
    _this.checkReadyRetryCount = 0;
    _this.maxCheckReadyRetries = 20;
    _this.checkReadyRetryDelay = 3000;
    _this.pendingResponses = {};
    _this.on = _this.on.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);
    _this.init(printerControlsAcceptors);
    return _this;
  }
  (0, _inherits2["default"])(Print, _Core);
  return (0, _createClass2["default"])(Print, [{
    key: "getCheckReady",
    value: function () {
      var _getCheckReady = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var payload, _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              payload = {
                action: "System.PrintService.CheckReady",
                uuid: (0, _uuid.v4)(),
                origin: "sdk-" + this.appName,
                timestamp: Number(BigInt(Date.now()) * 1000000n),
                request_uuid: "",
                data: "{}"
              };
              _context.next = 1;
              return this.connection.invoke("messaging", payload);
            case 1:
              _logger["default"].info("Check Ready", "Sent readiness check", "Print");
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              _logger["default"].error("Check Ready Failed", _t.message, "Print");
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getCheckReady() {
        return _getCheckReady.apply(this, arguments);
      }
      return getCheckReady;
    }()
  }, {
    key: "retryCheckReady",
    value: function () {
      var _retryCheckReady = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var _this2 = this;
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.checkReadyRetryCount < this.maxCheckReadyRetries) {
                this.checkReadyRetryCount++;
                _logger["default"].warn("Print Ready", "Not ready yet. Retrying (".concat(this.checkReadyRetryCount, "/").concat(this.maxCheckReadyRetries, ")"), "Print");
                setTimeout(function () {
                  _this2.getCheckReady();
                }, this.checkReadyRetryDelay);
              } else {
                _logger["default"].error("Print Ready", "Max retries reached. Still not ready.", "Print");
                this.trigger("ready", false);
              }
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function retryCheckReady() {
        return _retryCheckReady.apply(this, arguments);
      }
      return retryCheckReady;
    }()
  }, {
    key: "handleMessage",
    value: function () {
      var _handleMessage = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(message) {
        var _JSON$parse, ready, data, status_change, pending, _pending, uuid, _pending$, resolve, reject, _t2;
        return _regenerator["default"].wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(message.origin === "sdk-" + this.appName)) {
                _context3.next = 1;
                break;
              }
              return _context3.abrupt("return");
            case 1:
              _t2 = message.action;
              _context3.next = _t2 === "System.PrintService.Notify.Ready" ? 2 : _t2 === "System.SDK.ServiceNotification.Response" ? 3 : _t2 === "System.ServiceNotification" ? 5 : _t2 === "System.PrintService.StatusNotifications" ? 8 : 9;
              break;
            case 2:
              try {
                _JSON$parse = JSON.parse(message.data), ready = _JSON$parse.ready;
                if (ready === true) {
                  this.checkReadyRetryCount = 0;
                  if (!this.ready) {
                    this.ready = true;
                    this.trigger("ready", true);
                    _logger["default"].success("Initialization", "Module is now fully ready", "Print");
                  }
                } else {
                  this.retryCheckReady();
                }
              } catch (e) {
                _logger["default"].error("Parse error", "Invalid ready payload: " + e.message, "Print");
              }
              return _context3.abrupt("return");
            case 3:
              if (this.myServices.includes(message.origin)) {
                _context3.next = 4;
                break;
              }
              return _context3.abrupt("return");
            case 4:
              this.services[message.origin] = JSON.parse(message.data);
              _logger["default"].success("ServiceNotification", "New service added", message.origin);
              if (!this.ready) {
                this.ready = true;
                this.trigger("ready", true);
              }
              return _context3.abrupt("return");
            case 5:
              if (this.myServices.includes(message.origin)) {
                _context3.next = 6;
                break;
              }
              return _context3.abrupt("return");
            case 6:
              data = JSON.parse(message.data);
              _context3.next = 7;
              return this.connection.invoke("messaging", {
                uuid: (0, _uuid.v4)(),
                action: "".concat(data.serviceIdentification, ".ServiceNotification.Response"),
                origin: "sdk-" + this.appName,
                timestamp: Number(BigInt(Date.now()) * 1000000n),
                data: JSON.stringify({
                  serviceIdentification: "System.SDK",
                  serviceAbbreviation: "sdk-" + this.appName,
                  publicKey: this.publicKey
                })
              });
            case 7:
              this.services[message.origin] = data;
              _logger["default"].success("ServiceNotification", "New service added", message.origin);
              return _context3.abrupt("return");
            case 8:
              status_change = JSON.parse(message.data);
              this.trigger("statusChange", status_change);
              return _context3.abrupt("return");
            case 9:
              // Handle dynamic responses by UUID
              pending = Object.entries(this.pendingResponses).find(function (_ref) {
                var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
                  uuid = _ref2[0],
                  pending = _ref2[1];
                return message.action === pending.expectedAction && message.requestUuid === uuid;
              });
              if (pending) {
                _pending = (0, _slicedToArray2["default"])(pending, 2), uuid = _pending[0], _pending$ = _pending[1], resolve = _pending$.resolve, reject = _pending$.reject;
                delete this.pendingResponses[uuid];
                try {
                  resolve(JSON.parse(message.data));
                } catch (err) {
                  reject(err);
                }
              }
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleMessage(_x) {
        return _handleMessage.apply(this, arguments);
      }
      return handleMessage;
    }()
  }, {
    key: "createRequest",
    value: function createRequest(action) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var uuid = (0, _uuid.v4)();
      return {
        payload: {
          action: action,
          uuid: uuid,
          requestUuid: "",
          timestamp: Number(BigInt(Date.now()) * 1000000n),
          origin: "sdk-" + this.appName,
          data: JSON.stringify(data)
        },
        uuid: uuid
      };
    }
  }, {
    key: "sendRequest",
    value: function sendRequest(action) {
      var _this3 = this;
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var expectedAction = arguments.length > 2 ? arguments[2] : undefined;
      var _this$createRequest = this.createRequest(action, data),
        payload = _this$createRequest.payload,
        uuid = _this$createRequest.uuid;
      return new Promise(function (resolve, reject) {
        _this3.pendingResponses[uuid] = {
          resolve: resolve,
          reject: reject,
          expectedAction: expectedAction
        };
        _this3.connection.invoke("messaging", payload)["catch"](reject);
      });
    }
  }, {
    key: "getPrinters",
    value: function getPrinters() {
      return this.sendRequest("System.PrintService.GetPrinters", {}, "System.PrintService.GetPrinters.Response");
    }
  }, {
    key: "getStatus",
    value: function getStatus(printerName, configIndex) {
      var data = printerName && configIndex ? {
        printer_name: printerName,
        config: configIndex
      } : {};
      return this.sendRequest("System.PrintService.Status", data, "System.PrintService.Status.Response");
    }
  }, {
    key: "setPrinterStatus",
    value: function setPrinterStatus(faultName, faultState) {
      return this.sendRequest("System.PrintService.SetFault", {
        fault_name: faultName,
        fault_state: faultState
      }, "System.PrintService.SetFault.Response");
    }
  }, {
    key: "index",
    value: function index() {
      return this.sendRequest("System.PrintService.Index", {}, "System.PrintService.Index.Response");
    }
  }, {
    key: "getServiceInfo",
    value: function getServiceInfo() {
      return this.sendRequest("System.PrintService.ServiceInfo", {}, "System.PrintService.ServiceInfo.Response");
    }
  }, {
    key: "addPrintJob",
    value: function () {
      var _addPrintJob = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(template, printer, config) {
        "";
        var compressedTemplate, base64Template;
        return _regenerator["default"].wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              compressedTemplate = _pako["default"].gzip(template);
              base64Template = _bops["default"].to(compressedTemplate, "base64");
              return _context4.abrupt("return", this.sendRequest("System.PrintService.AddJob", {
                compressed: true,
                template: base64Template,
                printer: printer,
                config: config
              }, "System.PrintService.AddJob.Response"));
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function addPrintJob(_x2, _x3, _x4) {
        return _addPrintJob.apply(this, arguments);
      }
      return addPrintJob;
    }()
  }, {
    key: "printersControl",
    value: function () {
      var _printersControl = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        var uuid, origin, timestamp, payload, _t3;
        return _regenerator["default"].wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              timestamp = Number(BigInt(Date.now()) * 1000000n);
              _context5.next = 1;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(this.services["dpm"], {
                command: "System.PeripheralsManager.PrinterAcceptorsControl",
                params: JSON.stringify(this.printerControlsAcceptors)
              }, uuid, origin, timestamp);
            case 1:
              payload = _context5.sent;
              _context5.next = 2;
              return this.connection.invoke("messaging", payload);
            case 2:
              _logger["default"].info("Initialization", "Sent encrypted printer control message", "Print");
              _context5.next = 4;
              break;
            case 3:
              _context5.prev = 3;
              _t3 = _context5["catch"](0);
              _logger["default"].error("Initialization", "Failed to send encrypted printer control message", _t3);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 3]]);
      }));
      function printersControl() {
        return _printersControl.apply(this, arguments);
      }
      return printersControl;
    }()
  }, {
    key: "detectServices",
    value: function detectServices() {
      var _this4 = this;
      return Object.keys(this.services).some(function (key) {
        return _this4.myServices.includes(key);
      });
    }
  }, {
    key: "init",
    value: function init() {
      var _this5 = this;
      _logger["default"].info("Initialization", "Module initialization started, detecting services", "Print");
      if (!this.detectServices()) {
        _logger["default"].warn("Initialization", "No services found. In most cases, this is okay, services will show up soon.", "Print");
      }
      this.connection.on("messaging", this.handleMessage);
      this.getCheckReady();
      setTimeout(function () {
        return _this5.printersControl();
      }, 1000);
    }
  }]);
}(_core["default"]);